import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class CountDownService {
    constructor(private router : Router){
        this.setLimit(1.01);
        this.setTime("1:00")
    }

    private timerCountDown = new BehaviorSubject<string>("00:00");
    private timerlimit = new BehaviorSubject<any>(1.01);
    private timer = new BehaviorSubject<boolean>(false);

    cast = this.timerCountDown.asObservable();
    castLimit = this.timerlimit.asObservable();
    castTimer = this.timer.asObservable();

    setTime(value : string){
        this.timerCountDown.next(value);
    }
    setLimit(value : any){
        this.timerlimit.next(value);
    }
    setTimer(value : any){
        this.timer.next(value);
    }

    timeoutExpired(){
        this.setTimer(false);
        // localStorage.clear();
        this.router.navigate(["/kiosk/welcome"]);
    }

    destroy(){
        this.timerCountDown.complete();
        this.timerlimit.complete();
        this.timer.complete();
    }


}
